import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "fixed z-[3000] h-full w-full inset-0 bg-gray-800 bg-opacity-90 flex items-center justify-center"
};
var _hoisted_2 = {
  "class": "bg-gray-800 bg-opacity-0 w-4/12 h-1/2 mx-auto rounded-lg flex flex-col justify-center items-center"
};
var _hoisted_3 = {
  "class": "rounded-lg w-full mx-auto"
};
var _hoisted_4 = {
  "class": "pt-6 text-xl text-center mb-6 text-white font-normal"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$store.loadingText), 1)])])], 512)), [[_vShow, _ctx.$store.loading]]);
}